import PhotoSwipeGallery from '../model/photoswipe';

require('../lib/product');
require('../lib/product_analogs_sorting');

PhotoSwipeGallery('.photoswipe-gallery', '.swiper-slide:not(.swiper-slide-duplicate) a');
